import React, { Component } from "react";
import { Button } from "reactstrap";
import style from "./ConductAppoinment.module.css";
import api from "../../utils/Api";
import history from "../../utils/history";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import {
    checkIfPermitted,
    Permissions,
} from "../../services/RolePermissionService";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { Collapse } from "reactstrap";
import { connect } from "react-redux";
import {
    fetchPreInvoice,
    fetchCombinedPractitioner,
    fetchExternalPractitionerAutoComp
} from "../../redux";
import BillingComponent from "../Billing/BillingComponent/BillingComponent";
import { dateFormatter } from "../../utils/CommonUtil";
import { Select } from "antd";
import moment from 'moment';

const { Option } = Select;
export class ConductAppoinment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            relatedPartyName: "",
            physicalAddress: "",
            refNumber: "",
            phoneNumber: "",
            emailId: "",
            reason: "",
            notes: "",
            error: "",
            createNoteserror: "",
            isLoading: false,
            successMsg: "",
            errorMsg: "",
            successMessage: "",
            errorMessage: "",
            appointmentReasonType: "",
            appoinmentDetailsFetch: "",
            relatedPartyDetailsData: "",
            billing_policy_value: "",
            notesList: [],
            notesTypes: "1",
            notesText: "",
            isRefNote: false,
            ref_doctor_id: "",
            ref_doctor_name: "",
            ref_doctor_email: "",
            ref_doctor_address: "",
            emailError: "",
            isCreateDocumentsOpen: false,
            isAdditionalNotesOpen: false,
            isInvoiceSectionOpen: false,
            docTypeBtnLabel: "Create",
            isCaseFileDownloadin: "",
            isPatientFile: "",
            isError: "",
            isFormValid: false,
            isQuantityNumber: [],
            createNotes: [
                { document_type: "", document_note: "" },
            ],
            lineItemsArray: [],
            diagnosis_codes: [],
            vat_amount: 0,
            sub_total: 0,
            total: 0,
            practitionerOptions: [],
            writeoff_amount:0
        };
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0);
        document.title = 'Conduct Appointment - TechToMedix';

        let data = this.props.location.state;
        //console.log("data conduct", data)
        if (data) {
             this.props.fetchCombinedPractitioner("");
             this.props.fetchExternalPractitionerAutoComp("");
            await this.props.fetchPreInvoice(data && data.appointmentDetail && data.appointmentDetail.appointment_id,
                data && data.appointmentDetail && data.appointmentDetail.associated_related_party_id, "");

                if(this.props.preInvoiceData && this.props.preInvoiceData.preInvoiceList){
                  let obj = this.props.preInvoiceData.preInvoiceList;
                 // console.log("obj conduct", obj)
                  this.setState({
                      appointmentId:  data.appointmentDetail && data.appointmentDetail.appointment_id,
                    lineItemsArray: obj && obj.treatementDetail ? obj.treatementDetail : [],
                    diagnosis_codes: obj && obj.diagnosis ? obj.diagnosis : [],
                    total: obj && obj.invoice && obj.invoice.total ? obj.invoice.total : 0,
                    claimed_amount: obj && obj.invoice && obj.invoice.claimed_amount ? obj.invoice.claimed_amount : 0,
                    patient_liable_amount: obj && obj.invoice && obj.invoice.patient_liable_amount ? obj.invoice.patient_liable_amount : 0,
                    scheme_liable_amount: obj && obj.invoice && obj.invoice.scheme_liable_amount ? obj.invoice.scheme_liable_amount : 0,
                    amount_paid: obj && obj.invoice && obj.invoice.amount_paid ? obj.invoice.amount_paid : 0,
                    balance: obj && obj.invoice && obj.invoice.balance ? obj.invoice.balance : 0,
                    invoice_type_id: obj && obj.invoice && obj.invoice.invoice_type_id ? obj.invoice.invoice_type_id : "",
                    claimAsAssistant:  obj && obj.invoice && obj.invoice.claimAsAssistant ? obj.invoice.claimAsAssistant : 0,
                    age: obj && obj.age ? obj.age : "",
                    dob: obj && obj.dob ? dateFormatter(obj.dob) : "",
                    billing_policy_value: obj && obj.billing_policy_value ? obj.billing_policy_value : 0,
                    firstConsultationConfiguration:(obj && obj.firstConsultationConfiguration)||[],
                    billing_policy_id:obj && obj.billing_policy_id,
                    startdatetime:moment(moment(obj.appointment_date.bdate).format('YYYY-MM-DD') + ' ' + obj.appointment_date.start),
                    enddatetime:moment(moment(obj.appointment_date.bdate).format('YYYY-MM-DD') + ' ' + obj.appointment_date.end),
                    writeoff_amount:(obj && obj.invoice && obj.invoice.writeoff_amount)||0
                })
                }

            this.setState({
                appointmentReasonType: this.props.location.state && this.props.location.state.appointmentReasonLabel,
                appoinmentDetailsFetch: this.props.location.state && this.props.location.state.appointmentDetail,
                isPatientFile: this.props.location.state && this.props.location.state.isPatientFile,
                relatedPartyDetailsData: this.props.location.state && this.props.location.state.relatedPartyDetails,

            })

        }else{
          if(this.props.match && this.props.match.params && this.props.match.params.id){
            this.props.history.push({
              pathname: `/app/createappointment/${this.props.match.params.id}`,
            })
          }else{
            history.push("/appoinmentlist");
          }
        }
    }

    updateState = (data) => {
        this.setState({
            lineItemsArray: data.lineItemsArray,
            diagnosis_codes: data.diagnosis_codes,
            vat_amount: data.vatPrice,
            subTotal: data.subTotal,
            total: data.grandTotal,
            claimed_amount: data.claimed_amount,
            patient_liable_amount: data.patient_liable_amount,
            scheme_liable_amount: data.scheme_liable_amount,
            amount_paid: data.amount_paid,
            balance: data.balance,
        })
    }


    updateHeightWeight = (data) => {
        this.setState({
          height: data.height,
          weight: data.weight,
        })
      }

    handleInputChangeTypes = (e) => {
        const { name, value } = e.target;
        this.setState({
            notesTypes: value,
            isRefNote: value === "2" ? true : false,
            docTypeBtnLabel: "Create",
            notesText: "",
            ref_doctor_id: "",
            ref_doctor_name: "",
            ref_doctor_email: "",
            ref_doctor_address: ""
        })
    };


    handleInputRefDoctorName = (value, name) => {
        const practitionerObj = this.props.externalPractitionersAutoCompData &&
                    this.props.externalPractitionersAutoCompData.externalPractitionersAutoComp &&
                    this.props.externalPractitionersAutoCompData.externalPractitionersAutoComp.find((element, index) => {
                        return element.practitioner_id === value;
                    });
        this.setState({
            ref_doctor_name: practitionerObj && practitionerObj.practitioner_name ? practitionerObj.practitioner_name : "",
            ref_doctor_id: value,
            ref_doctor_email: practitionerObj && practitionerObj.email ? practitionerObj.email : "",
            ref_doctor_address: practitionerObj && practitionerObj.physical_address ? practitionerObj.physical_address : "",
        }, () => {
            this.removeError();
        })
    };
    handleInputRefDoctorEmail = (e) => {
        const { name, value } = e.target;
        this.setState({
            ref_doctor_email: value
        }, () => {
            this.validateEmail(value);
            this.removeError();
        })
    };
    handleInputRefDoctorAddress = (e) => {
        const { name, value } = e.target;
        this.setState({
            ref_doctor_address: value
        }, () => {
            this.removeError();
        })
    };

    handleInputChangeNotes = (e) => {
        const { name, value } = e.target;
        this.setState({
            notesText: value
        }, () => {
            this.removeError();
        })
    };

    validateEmail = (email) => {
        const pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        const result = pattern.test(email);
        this.setState({
            emailError: result !== true
        });
    };

    // Created notes array
    noteAdd = () => {
        if (
            this.state.notesText === ""
        ) {
            this.setState({
                createNoteserror: "Please filled out mandatory filled"
            });
        } else if (
            (this.state.isRefNote && this.state.ref_doctor_id === "") ||
            (this.state.isRefNote && this.state.ref_doctor_name === "") ||
            (this.state.isRefNote && this.state.ref_doctor_email === "") ||
            (this.state.isRefNote && this.state.ref_doctor_address === "") ||
            (this.state.isRefNote && this.state.emailError === true)
        ) {
            this.setState({
                createNoteserror: "Please filled out mandatory filled"
            });
        } else {
            const notesListData = [...this.state.notesList];
            const exist = notesListData.findIndex((element) => {
                return element.notesTypes === this.state.notesTypes;
            });
            if (exist === -1 && this.state.docTypeBtnLabel === "Create") {
                if (this.state.isRefNote) {
                    notesListData.push({
                        notesTypes: this.state.notesTypes,
                        notesText: this.state.notesText,
                        ref_doctor_id: this.state.ref_doctor_id,
                        ref_doctor_name: this.state.ref_doctor_name,
                        ref_doctor_email: this.state.ref_doctor_email,
                        ref_doctor_address: this.state.ref_doctor_address,
                    });
                    // reset after push data into array
                    this.setState({
                        notesText: "",
                        notesTypes: "1",
                        ref_doctor_id: "",
                        ref_doctor_name: "",
                        ref_doctor_email: "",
                        ref_doctor_address: "",
                        isRefNote: false
                    })
                } else {
                    notesListData.push({
                        notesTypes: this.state.notesTypes,
                        notesText: this.state.notesText
                    });
                    // reset after push data into array
                    this.setState({
                        notesText: "",
                        notesTypes: "1",
                    })
                }
            } else if (exist > -1 && this.state.docTypeBtnLabel === "Update") {
                // notesListData[exist] = { notesTypes, notesText };
                if (this.state.isRefNote) {
                    notesListData[exist] = {
                        notesTypes: this.state.notesTypes,
                        notesText: this.state.notesText,
                        ref_doctor_id: this.state.ref_doctor_id,
                        ref_doctor_name: this.state.ref_doctor_name,
                        ref_doctor_email: this.state.ref_doctor_email,
                        ref_doctor_address: this.state.ref_doctor_address,
                    };
                } else {
                    notesListData[exist] = {
                        notesTypes: this.state.notesTypes,
                        notesText: this.state.notesText
                    };
                }
            } else if (exist > -1 && this.state.docTypeBtnLabel === "Create") {
                this.setState({
                    createNoteserror: "You cannot create more than one note of each type."
                })
                setTimeout(() => {
                    this.setState({
                        createNoteserror: ""
                    })
                }, 2500);
                return false;
            }
            this.setState({
                notesList: notesListData
            })
            //console.log("After notes obj add", this.state.notesList);
        }
    };


    removeError = () => {
        if (!this.state.isRefNote) {
            if (this.state.notesText !== "") {
                this.setState({
                    createNoteserror: ""
                })
            }
        } else {
            if (
                this.state.notesText !== "" &&
                this.state.ref_doctor_id !== "" &&
                this.state.ref_doctor_name !== "" &&
                this.state.ref_doctor_email !== "" &&
                this.state.ref_doctor_address !== ""
            ) {
                this.setState({
                    createNoteserror: ""
                })
            }
        }
    };

    // Edit notes array
    onEditClick = (index, notesTypes) => {
        this.setState({
            docTypeBtnLabel: "Update",
            isRefNote: notesTypes === "2" ? true : false,
            createNoteserror: "",
            notesTypes: this.state.notesList[index].notesTypes,
            notesText: this.state.notesList[index].notesText,
            ref_doctor_id: this.state.notesList[index].ref_doctor_id,
            ref_doctor_name: this.state.notesList[index].ref_doctor_name,
            ref_doctor_email: this.state.notesList[index].ref_doctor_email,
            ref_doctor_address: this.state.notesList[index].ref_doctor_address,
        })
    };


    handleRemoveNoteClick = (index) => {
        const notesListData = [...this.state.notesList];
        notesListData.splice(index, 1);

        this.setState({
            notesList: notesListData,
            createNoteserror: "",
            notesTypes: "1",
            notesText: "",
            ref_doctor_id: "",
            ref_doctor_name: "",
            ref_doctor_email: "",
            ref_doctor_address: "",
            docTypeBtnLabel: "Create",
            isRefNote: false
        })
    };

    handleChange = (event) => {
        const val = event.target.value;
        this.setState({
            notes: val
        })
    };


    // Download patient file
    onDownloadSubmitFile = async () => {
        this.setState({
            isCaseFileDownloading: true,
        });

        // headers
        const headers = {
            Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
            Accept: "application/pdf",
        };
        // console.log(
        //     "++++++++++=",
        //     this.props.location.state.appointmentDetail.associated_related_party_id
        // );

        const payload = {
            patient_id:
                this.props.location.state.appointmentDetail &&
                this.props.location.state.appointmentDetail.associated_related_party_id,
        };

        try {
            const response = await api.post(
                "appointment/patientfile/download",
                payload,
                {
                    headers: headers,
                    responseType: "blob",
                }
            );

            if (response.status === 200) {
                this.setState({
                    isCaseFileDownloading: false,
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                if (this.state.relatedPartyDetailsData && this.state.relatedPartyDetailsData.fileNumber) {
                    link.setAttribute("download", `${this.state.relatedPartyDetailsData.fileNumber}.pdf`);
                } else {
                    link.setAttribute("download", `${this.state.relatedPartyDetailsData.name}.pdf`);
                }
                document.body.appendChild(link);
                link.click();


                if (response.status === 200) {
                    this.setState({
                        isCaseFileDownloading: false,
                        successMsg: "Case file download successfully"
                    });

                    setTimeout(() => {
                        this.setState({
                            successMsg: ""
                        });
                    }, 1000);
                }
            }
        } catch (error) {
            console.log("Error in download", error);
            this.setState({
                isCaseFileDownloading: false,
                errorMsg: "Error in download"
            });
            setTimeout(() => {
                this.setState({
                    errorMsg: ""
                });
            }, 2000);
        }
    };



    // Validations for diagonsis
    diagonsisIsValid = async () => {
        this.setState({
            isFormValid: true,
            isError: ""
        });
        const formData = new FormData();

        formData.append("appointment_id", this.props.match.params.id);
        formData.append("notes", this.state.notes);

        //formData.append("diagnosis", JSON.stringify(diagInputList));
        formData.append("line_items", JSON.stringify(this.state.lineItemsArray));
        formData.append("diagnosis_codes", JSON.stringify(this.state.diagnosis_codes));
        formData.append("total", this.state.total);
        formData.append("height", this.state.height?this.state.height: "");
        formData.append("weight", this.state.weight?this.state.weight: "");
        //formData.append("claimAsAssistant", this.state.claimAsAssistant);
        let vatPercent = localStorage.getItem("SETTING_INFO") &&
            JSON.parse(localStorage.getItem("SETTING_INFO")).vat_percent;
        formData.append("vat_percent", vatPercent);

        const doctorNotesData = this.state.notesList.map((item) => ({
            notes: item.notesText,
            lk_document_type_id: item.notesTypes,
            referring_practioner_id: item.ref_doctor_id,
            referred_doctor_name: item.ref_doctor_name,
            referred_doctor_email: item.ref_doctor_email,
            referred_doctor_address: item.ref_doctor_address,
        }));

        formData.append("doctor_notes", JSON.stringify(doctorNotesData));

        formData.append(
            "appointmentDetail",
            JSON.stringify(this.state.appoinmentDetailsFetch)
        );

        const headers = {
            Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
        try {
            const response = await api.post("appointment/conduct", formData, {
                headers: headers,
            });
            if (response.status === 200) {
                this.setState({
                    isLoading: false,
                    successMessage: "Appointment conducted successfully! Please wait while redirecting..."
                });
                setTimeout(() => {

                    this.setState({
                        successMessage: ""
                    });
                    if(this.props.match && this.props.match.params && this.props.match.params.id){
                        this.props.history.push({
                          pathname: `/app/createappointment/${this.props.match.params.id}`,
                        })
                      }else{
                        history.push("/appoinmentlist");
                      }
                }, 1000);
            }
        } catch (error) {
            this.setState({
                isLoading: false,
                errorMessage: "Error!"
            });
            setTimeout(() => {
                this.setState({
                    isLoading: false,
                    errorMessage: ""
                });
            }, 1000);
            console.log("Error in onsubmit of conduct appointment - ", this.state.error);
        }
        // }
        // }
        // }
    };

    toggleCreateDocuments = () => {
        this.setState({
            isCreateDocumentsOpen: !this.state.isCreateDocumentsOpen,
        });
    }
    toggleAdditionalDocuments = () => {
        this.setState({
            isAdditionalNotesOpen: !this.state.isAdditionalNotesOpen,
        });
    }
    toggleInvoiceSection = () => {
        this.setState({
            isInvoiceSectionOpen: !this.state.isInvoiceSectionOpen,
        });
    }

    // Posting conduct appoinment data
    onSubmit = async () => {
        this.diagonsisIsValid();
    };

    handleCheckbox = (event) => {
      event.persist();
      const val = event.target.checked;
      const name = event.target.name;
      this.setState(
        {
          [name]: val ? 1 : 0,
        });
    };

    render() {
      
     const practitionerOptions = this.props.location.state && this.props.location.state.practitionerOptions;
     const combinedPractitioners = this.props.combinedPractitionersData &&
     this.props.combinedPractitionersData.combinedPractitioners;
     const externalPractitionersAutoCompData = this.props.externalPractitionersAutoCompData &&
     this.props.externalPractitionersAutoCompData.externalPractitionersAutoComp;
        const relatedPartyDetailsData = this.state.relatedPartyDetailsData;
        return (
            <div className={style.conductAppoWrapper}>
                <div className="row">
                    <div className="col-lg-12">
                        <h3>Conduct Appointments</h3>
                    </div>
                    <div className="col-lg-12 intro-text">
                        <p className="mb-4">
                            The doctor can select the procedures for the diagnosis and add notes
                            if any. The document section allows to create letters, doctor note
                            and prescription. The text added in the box will be added to the
                            selected document type. The create button will create the document.
                            It can be edited or deleted as needed. The end appointment button
                            will create a patient file having all the details for this
                            appointment. The patient will go to front desk and pay the invoice.
          </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className={style.rPartyDetailsWrapper}>
                            <h6 className={style.partyDetails}>Patient Details :</h6>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Name</label>:{" "}
                                    {relatedPartyDetailsData && relatedPartyDetailsData.name}
                                </div>
                                <div className="col-md-6">
                                    <label>Physical Address</label>:{" "}
                                    {this.props.location.state &&
                                        this.props.location.state.relatedPartyDetails.PhysicalAddress ?
                                        this.props.location.state.relatedPartyDetails.PhysicalAddress : "Not Available"}{" "}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Reference Number</label>:{" "}
                                    {this.props.location.state &&
                                        this.props.location.state.relatedPartyDetails.refnumber}
                                </div>
                                <div className="col-md-6">
                                    <label>Phone Number</label> :{" "}
                                    {relatedPartyDetailsData && relatedPartyDetailsData.phoneNumber ?
                                        relatedPartyDetailsData.phoneNumber : "Not Available"}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Email Id </label>:{" "}
                                    {relatedPartyDetailsData && relatedPartyDetailsData.emailId}
                                </div>
                                <div className="col-md-6">
                                    <label>Reason </label>: {this.state.appointmentReasonType}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Notes </label>:{" "}
                                    {relatedPartyDetailsData && relatedPartyDetailsData.notes ? relatedPartyDetailsData.notes : "Not Available"}
                                </div>
                                <div className="col-md-6"></div>
                            </div>
                            {this.state.isPatientFile && (
                                <div className="row">
                                    <div className="col-lg-6">
                                        <p className={style.caseFileHeading}>Case File</p>
                                        <span
                                            class={style.caseFileWrapper}
                                            onClick={this.onDownloadSubmitFile}
                                        >
                                            <i class={`fa fa-paperclip mr-2 ${style.caseFileIcon}`}></i>
                                            {relatedPartyDetailsData && relatedPartyDetailsData.fileNumber && (
                                                <span> {`${relatedPartyDetailsData.fileNumber}.pdf`} </span>
                                            )}
                                            {relatedPartyDetailsData && !relatedPartyDetailsData.fileNumber && (
                                                <span> {`${relatedPartyDetailsData.name}.pdf`} </span>)}
                                            {this.state.isCaseFileDownloading ? (
                                                <span className={`ml-2 ${style.loadingCaseFileWrapper}`}>
                                                    <img src={ttmLoader} alt="loader" className={style.loading} />
                                                </span>
                                            ) : (
                                                    <span>
                                                        {this.state.successMsg && (
                                                            <span className={style.caseFilesuccessMessage}>
                                                                {this.state.successMsg}
                                                            </span>
                                                        )}
                                                        {this.state.errorMsg && (
                                                            <span className={style.caseFileerrorMessage}>
                                                                {this.state.errorMsg}
                                                            </span>
                                                        )}
                                                    </span>
                                                )}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Additional notes section start */}
                <div className={`${style.diagnosisMainWrapper} mt-4`}>
                    <div >
                        <div className={`${style.createDocumentsHeader}`} onClick={this.toggleAdditionalDocuments}>
                            <h5>Additional Notes</h5>
                            {this.state.isAdditionalNotesOpen ? (
                                <i className="fa fa-angle-up" aria-hidden="true"></i>
                            ) : (
                                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                                )}
                        </div>
                    </div>


                    <Collapse isOpen={this.state.isAdditionalNotesOpen}>
                        <hr />
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    {/* <label htmlFor="add_notes">Additional Notes</label> */}
                                    <textarea
                                        className="form-control"
                                        rows={2}
                                        id="add_notes"
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </Collapse>

                </div>
                {/* Additional notes section end */}

                {/* Create documents section start */}
                {checkIfPermitted(Permissions.MANAGE_LETTERS) && (
                    <div className={`${style.diagnosisMainWrapper} mt-4`}>
                        <div >
                            <div className={`${style.createDocumentsHeader}`} onClick={this.toggleCreateDocuments}>
                                <h5>Create Documents</h5>
                                {this.state.isCreateDocumentsOpen ? (
                                    <i className="fa fa-angle-up" aria-hidden="true"></i>
                                ) : (
                                        <i className="fa fa-angle-down" aria-hidden="true"></i>
                                    )}
                            </div>
                        </div>
                        <Collapse isOpen={this.state.isCreateDocumentsOpen}>
                            <hr />
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="document_type">Type of Documents</label>
                                        <select
                                            className="form-control"
                                            id="document_type"
                                            name="document_type"
                                            onChange={(e) => this.handleInputChangeTypes(e)}
                                            value={this.state.notesTypes}
                                        >
                                            <option value="1">Doctor Note</option>
                                            <option value="2">Referral Note</option>
                                            <option value="3">Prescription</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {this.state.isRefNote && (
                                <div className="row">
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            {/* <select
                                                className="form-control"
                                                id="ref_doctor_name"
                                                name="ref_doctor_name"
                                                placeholder="Referred doctor name * "
                                                value={this.state.ref_doctor_name}
                                                onChange={(e) => {
                                                    this.handleInputRefDoctorName(e);
                                                }}
                                            // onBlur={() => handleNotesBlurChange()}
                                            >
                                                {externalPractitionersAutoCompData && 
                                                externalPractitionersAutoCompData.map((item, index)=>(
                                                <option value={item.practitioner_id}>{item.practitioner_name}</option>
                                                ))}
                                            </select> */}
                                            <Select
                                                showSearch
                                                allowClear={true}
                                                name="ref_doctor_name"
                                                placeholder="Search Practitioner"
                                                optionFilterProp="children"
                                                onChange={(value, event) => this.handleInputRefDoctorName(value, "ref_doctor_name")}
                                                filterOption={(input, option) =>
                                                option.children
                                                    .toLowerCase()
                                                    .indexOf(input.toLowerCase()) >= 0
                                                }
                                                value={this.state.ref_doctor_id || undefined}
                                            >
                                                {externalPractitionersAutoCompData &&
                                                externalPractitionersAutoCompData.map((element, index) => (
                                                    <Option key={index} value={element.practitioner_id}>
                                                    {element.practitioner_name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${this.state.emailError ? "is-invalid" : ""}`}
                                                id="ref_doctor_email"
                                                name="ref_doctor_email"
                                                placeholder="Referred doctor email * "
                                                value={this.state.ref_doctor_email}
                                                onChange={(e) => {
                                                    this.handleInputRefDoctorEmail(e);
                                                }}
                                            // onBlur={() => handleNotesBlurChange()}
                                            />
                                            {this.state.emailError ? (
                                                <span className="error">
                                                    Please Enter valid email address
                                                </span>
                                            ) : (
                                                    ""
                                                )}
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="ref_doctor_address"
                                                id="ref_doctor_address"
                                                placeholder="Referred doctor address * "
                                                value={this.state.ref_doctor_address}
                                                onChange={(e) => {
                                                    this.handleInputRefDoctorAddress(e);
                                                }}
                                            // onBlur={() => handleNotesBlurChange()}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <textarea
                                            className="form-control"
                                            rows={3}
                                            id="document_note"
                                            name="document_note"
                                            placeholder="Enter notes here"
                                            onChange={(e) => this.handleInputChangeNotes(e)}
                                            // onBlur={() => handleNotesBlurChange()}
                                            value={this.state.notesText}
                                        />
                                        <span>
                                            <small className="error">{this.state.createNoteserror}</small>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className={`col-md-12 ${style.createNoteWrapper}`}>
                                    <button
                                        className="tmed-btn tmed-primary-btn"
                                        onClick={() => this.noteAdd()}
                                    >
                                        {this.state.docTypeBtnLabel}
                                    </button>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <ul className={style.notesViewWrapper}>
                                        {this.state.notesList.map((element, i) => {
                                            return (
                                                <li key={i}>
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <p>
                                                                {element.notesTypes === "2"
                                                                    ? "Referral Notes"
                                                                    : element.notesTypes === "3"
                                                                        ? "Prescription"
                                                                        : "Doctor Note"}
                                                            </p>
                                                        </div>
                                                        <div className="col-md-8 d-flex">
                                                            {element.notesText && (
                                                                <div className="mr-3 text-align-justify">
                                                                    <p>{element.notesText}</p>
                                                                </div>)}

                                                            {element.ref_doctor_name && (
                                                                <div className={`mr-3 ${style.borderLeft}`}>
                                                                    <p>{element.ref_doctor_name}</p>
                                                                </div>)}

                                                            {element.ref_doctor_email && (
                                                                <div className={`mr-3 ${style.borderLeft}`}>
                                                                    <p className={style.emailText}>
                                                                        {element.ref_doctor_email}
                                                                    </p>
                                                                </div>)}

                                                            {element.ref_doctor_address && (
                                                                <div className={`mr-3 ${style.borderLeft}`}>
                                                                    <p>{element.ref_doctor_address}</p>
                                                                </div>)}
                                                        </div>
                                                        <div className="col-md-1 justify-content-md-end">
                                                            <i
                                                                className={`fa fa-pencil-square-o ${style.editIcon}`}
                                                                onClick={() => this.onEditClick(i, element.notesTypes)}
                                                            ></i>
                                                        </div>
                                                        <div className="col-md-1 justify-content-md-end">
                                                            <i
                                                                className={`fa fa-times ${style.removeIcon}`}
                                                                onClick={() => this.handleRemoveNoteClick(i)}
                                                            ></i>
                                                        </div>
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </Collapse>
                    </div>
                )}
                {/* Create documents section end */}

                <Formik
                    initialValues={this.state}
                    enableReinitialize={true}
                    validationSchema={Yup.object().shape({
                        lineItemsArray: Yup.array().of(
                            Yup.object().shape({
                                line_type: Yup.string()
                                    .required("Required!"),
                                tariff_code: Yup.string()
                                    .required("Required!"),
                                diagnosis_code: Yup.string()
                                    .required("Required!"),
                                doctor_id: Yup.string()
                                    .required("Required!"),
                                quantity: Yup.string()
                                    .required("Required!")
                                    .matches(/^[0-9]\d{0,9}(\.\d{1,2})?%?$/, "Only numbers allowed"),
                                price: Yup.string()
                                    .required("Required!")
                                    .matches(/^[0-9]\d{0,9}(\.\d{1,2})?%?$/, "Only numbers allowed"),
                            })
                        ),
                    })}
                    onSubmit={this.onSubmit}
                >
                    {({ errors, status, touched }) => (

                        <Form>

                            {/* invoice section start */}

                            <div className={`${style.invoiceSectionWrapper} mt-4`}>
                                <div className={`${style.invoiceSectionHeader}`} onClick={this.toggleInvoiceSection}>
                                    <h5>Invoice Section</h5>
                                    {this.state.isInvoiceSectionOpen ? (
                                        <i className="fa fa-angle-up" aria-hidden="true"></i>
                                    ) : (
                                            <i className="fa fa-angle-down" aria-hidden="true"></i>
                                        )}
                                </div>
                                <Collapse className="conduct-collapse" isOpen={this.state.isInvoiceSectionOpen}>
                                    <hr />
                                    {/* <div className="row">
                                    <div className="col-md-6 mb-1"></div>
                                    <div className="mb-1 col-md-6 order-3 order-md-2 d-flex justify-content-start justify-content-md-end">
                                      <div
                                        className={`custom-control custom-checkbox ${style.claimAsAssistant}`}
                                      >
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="claimAsAssistant"
                                          name="claimAsAssistant"
                                          onChange={this.handleCheckbox}
                                          checked={this.state.claimAsAssistant === 1}
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="claimAsAssistant"
                                        >
                                          Claim as Assistant
                                          </label>
                                      </div>
                                    </div>
                                    </div> */}

                                    <BillingComponent
                                        // {...[lineItemsArray]} 
                                        state={{
                                            related_party: this.state.appoinmentDetailsFetch &&
                                                this.state.appoinmentDetailsFetch.associated_related_party_id,
                                            requested_professional: this.state.appoinmentDetailsFetch &&
                                                this.state.appoinmentDetailsFetch.requested_related_party_id,
                                            height: this.state.appoinmentDetailsFetch &&
                                                this.state.appoinmentDetailsFetch.height,
                                            weight: this.state.appoinmentDetailsFetch &&
                                                this.state.appoinmentDetailsFetch.weight,
                                            appoinment_id: this.state.appointmentId,
                                            lineItemsArray: this.state.lineItemsArray,
                                            diagnosis_codes: this.state.diagnosis_codes,
                                            total: this.state.total,
                                            claimed_amount: this.state.claimed_amount,
                                            patient_liable_amount: this.state.patient_liable_amount,
                                            scheme_liable_amount: this.state.scheme_liable_amount,
                                            amount_paid: this.state.amount_paid,
                                            balance: this.state.balance,
                                            claimAsAssistant: this.state.claimAsAssistant,
                                            billing_policy_value: this.state.billing_policy_value,
                                            age: this.state.age,
                                            dob: this.state.dob,
                                            firstConsultationConfiguration:this.state.firstConsultationConfiguration,
                                            billing_policy_id:this.state.billing_policy_id,
                                            //invoice_type_id: this.state.invoice_type_id
                                            startdatetime:this.state.startdatetime,
                                            writeoff_amount:this.state.writeoff_amount
                                        }}
                                        {...{ errors, status, touched }}
                                        isConductAppointment={true}
                                        practitionerOptions={practitionerOptions}
                                        combinedPractitioners={combinedPractitioners}
                                        updateState={this.updateState}
                                        updateHeightWeight={this.updateHeightWeight}
                                    ></BillingComponent>
                                </Collapse>

                            </div>
                            {/* invoice section end */}

                            <div className="row">
                                <div className="col-md-12">
                                {Object.keys(errors).length > 0 && (
                                            <div className="text-danger">
                                                Please fill all mandatory fields!
                                            </div>
                                        )}
                                    {this.state.isError && (
                                        <div className={`error ${style.errorText}`}>{this.state.isError}</div>
                                    )}
                                </div>
                            </div>

                            <div className={`row ${style.conductBtnWrapper}`}>
                                <div className="col-md-12">
                                    <div>
                                        {/* <Button className="ttm-primary-btn mr-2">Create Invoice</Button> */}
                                        <Button
                                            className="ttm-primary-btn"
                                            type="submit"
                                        // onClick={onSubmit}
                                        >
                                            End Appointment
            </Button>
                                    </div>
                                </div>
                            </div>

                        </Form>)}
                </Formik>
                <div className="row ">
                    <div className="col-md-12">
                        {this.state.isLoading ? (
                            <div className={`error ${style.loadingWrapper}`}>
                                <img src={ttmLoader} alt="loader" className={style.loading} />
                            </div>
                        ) : (
                                <div>
                                    {this.state.successMessage && (
                                        <p className={style.successMessage}>{this.state.successMessage}</p>
                                    )}
                                    {this.state.errorMessage && <p className={style.errorMessage}>{this.state.errorMessage}</p>}
                                </div>
                            )}
                    </div>
                </div>
            </div>
        );

    }

}


const mapStateToProps = (state) => {
    return {
        preInvoiceData: state.preInvoiceList,
        combinedPractitionersData: state.combinedPractitioners,
        externalPractitionersAutoCompData: state.externalPractitionersAutoComp,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPreInvoice: (appointmentId, relatedPartyId, conductAPPId) =>
            dispatch(fetchPreInvoice(appointmentId, relatedPartyId, conductAPPId)),
        fetchCombinedPractitioner: (practitionerName) => dispatch(fetchCombinedPractitioner(practitionerName, 1)),
        fetchExternalPractitionerAutoComp: (practitionerName) => dispatch(fetchExternalPractitionerAutoComp(practitionerName, 1)),
    };
};

//export default ConductAppoinment;
export default connect(mapStateToProps, mapDispatchToProps)(ConductAppoinment);